<template>
    <div class="videoSliderSection">
        <fade-transition @before-enter="onBeforeEnter"
                         @after-leave="onAfterLeave" mode="out-in" group>
            <editor-slide v-for="(slide, index) in slides"
                          v-if="slide && index === slideIdx"
                          :key="index"
                          :slide="slide"
                          :index="index"
                          ref="slide"
            ></editor-slide>
        </fade-transition>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'

    export default {
        mixins: [],
        props: ['slides', 'slideIdx'],
        data() {
            return {
                show: false,
                hasWhiteBg: false,
            }
        },
        computed: {},
        created() {
        },
        beforeDestroy() {
        },
        mounted() {
            this.clearInvertTheme()
        },
        watch: {
            'slideIdx': 'onSlideIdx',
        },
        methods: {
            ...mapActions('ui', [
                'invertTheme',
            ]),
            onBeforeEnter(el) {
                this.playVideo(el)
            },
            onAfterLeave(el) {
                this.pauseVideo(el)
            },

            isWhiteBg(slide) {
                //console.log('isWhiteBg', slide)
                let keywords = slide && slide.keywords || []
                let hasWhiteBg = keywords.indexOf('WHITE BG') !== -1
                this.invertTheme(hasWhiteBg)

                return hasWhiteBg
            },
            clearInvertTheme() {
                this.invertTheme(false)
            },
            playVideo(el) {
                el.querySelector('video')
                    .play()
                    .catch(error => {
                    });
            },
            pauseVideo(el) {
                el.querySelector('video').pause()
            },
            pauseAllVideos() {
                document.querySelectorAll('video').forEach(function (video) {
                    video.pause();
                })
            },
            onSlideIdx(new_, old_) {
                if (new_ === null) {
                    this.pauseAllVideos()
                    this.clearInvertTheme()
                } else {
                    this.isWhiteBg(this.slides[new_])
                }
            }
        },
    }
</script>

